<template lang="pug">
  #entity-property.right-panel.md-elevation-1.md-scrollbar.md-theme-default
    .md-layout-row.header
      .md-flex(v-if="property")
        md-button.md-icon-button.md-dense.close.small(v-bind:to="{ name: 'Entity', params: { code: $route.params.code, entity_code: $route.params.entity_code}, query: $route.query}"): md-icon close
        md-field
          label Название
          md-input( v-model="property.name" v-bind:disabled="sending")
        md-field
          label Символьный код
          md-input( v-model="property.code" v-bind:disabled="sending")
        md-field
          label Сортировка
          md-input( v-model="property.sort" type="number" v-bind:disabled="sending")
        md-field(v-if="Object.keys(entities).length")
          label Сущность
          md-select(v-model="property.field_entity" v-bind:disabled="sending")
            md-option(v-for="entity in entities" v-bind:key="entity.code" v-bind:value="entity.code") {{entity.name}}
        md-field
          label Тип свойства
          md-select(v-model="property.field_type" v-bind:disabled="sending")
            md-option(v-for="propertyType in propertyTypes" v-bind:key="propertyType.code" v-bind:value="propertyType.code") {{propertyType.name}}
        md-field
          label Размер поля
          md-select(v-model="property.size" v-bind:disabled="sending")
            md-option(value="100") Полноразмерное (100%)
            md-option(value="80") Большое (90%)
            md-option(value="80") Большое (80%)
            md-option(value="75") Большое (75%)
            md-option(value="60") Среднее (60%)
            md-option(value="50") Среднее (50%)
            md-option(value="40") Среднее (40%)
            md-option(value="30") Маленькое (30%)
            md-option(value="25") Маленькое (25%)
            md-option(value="20") Маленькое (20%)
            md-option(value="10") Маленькое (10%)

        div
          md-switch(v-bind:disabled="sending" v-if="(property.field_type == 'radio') ? true : false" v-model="property.multiply" disabled) Множественное
          md-switch(v-bind:disabled="sending" v-if="(property.field_type != 'radio') ? true : false" v-model="property.multiply") Множественное
        div
          md-switch(v-model="property.require" v-bind:disabled="sending") Обязательное
        div
          md-switch(v-model="property.active" v-bind:disabled="sending") Активно
        div
          md-switch(v-model="property.default" v-bind:disabled="sending") Является стандартным
        md-button.md-primary(@click="updateProperty()") Сохранить
        md-button.md-accent(v-bind:to="{ name: 'Entity', params: { code: $route.params.code, entity_code: $route.params.entity_code}, query: $route.query}") Отмена
</template>

<script>
  import ModuleMenu from './menu.vue';
  import EditArea from '@/components/EditArea'

  export default {
    data() {
      return {
        sending: false,
        property: {
          default: false,
          multiply: false,
          require: false,
          active: false
        },
        propertyTypes: [
          {code: 'text',     name: 'Поле ввода'},
          {code: 'textarea', name: 'Область ввода'},
          {code: 'checkbox', name: 'Чекбокс'},
          {code: 'number',   name: 'Число'},
          {code: 'radio',    name: 'Радио кнопка'},
          {code: 'select',   name: 'Поле выбора'},
          {code: 'file',     name: 'Файл'},
        ]
      }
    },
    components: {
      ModuleMenu,
      EditArea
    },
    computed: {
      properties() {
        return this.$store.state.module.entity_properties;
      },
      entities() {
        return this.$store.state.module.entities;
      },
    },
    watch: {
      'property'(newVal){
        if (newVal['field_type'] && newVal['field_type'] == 'radio') {
          this.property.multiply = true;
        }
      },
      'properties'(newVal) {
        this.getProperty();
      },
      '$route.params.entity_prop_code'() {
        this.$store.commit('openRightPanel');
        this.getProperty();
      },
    },
    created() {
      this.$store.commit('openRightPanel');
      this.$store.dispatch('module/getModuleEntities');
      this.$store.dispatch('module/getModuleEntitiesProperties');
      this.getProperty();
    },
    methods: {
      updateProperty(){
        this.property.module_code = this.$route.params.code;
        if (this.$route.params.entity_prop_code && this.$route.params.entity_prop_code != 'new') {

          this.$store.commit('showProgressBar');
          this.sending = true;

          this.$store.dispatch('module/putModuleEntitiesProperty', this.property).then(response => {
              this.$store.dispatch('module/getModuleEntitiesProperties');
              this.$store.commit('hideProgressBar');
              this.sending = false;
              this.$router.push({ name: 'Entity', params: {entity_code: this.$route.params.entity_code }});
          }, response => {
              this.$store.dispatch('module/getModuleEntitiesProperties');
              this.$store.commit('hideProgressBar');
              this.sending = false;
              this.$store.commit('handleSnackError', [response, 6000, 'error']);
          });
        } else {
          this.$store.commit('showProgressBar');
          this.sending = true;
          this.$store.dispatch('module/postModuleEntitiesProperty', this.property).then(response => {
            if (response.status == 200) {
              this.$store.commit('closeRightPanel');
              this.$store.dispatch('module/getModuleEntitiesProperties');
              this.$router.push({ name: 'Entity', params: {entity_code: this.$route.params.entity_code} });
              this.$store.commit('hideProgressBar');
              this.sending = false;
            }
          }, response => {
            this.$store.commit('hideProgressBar');
            this.sending = false;
            this.$store.commit('showShandleSnackErrornackbar', [response, 6000, 'error']);
          });
        }
      },
      getProperty() {
        if(Object.keys(this.properties).length && this.$route.params.entity_prop_code && this.$route.params.entity_prop_code != 'new') {
          this.property = this.properties.find(x => x.code === this.$route.params.entity_prop_code);
          this.property.multiply = (this.property.multiply == '1') ? true : false;
          this.property.require  = (this.property.require == '1')  ? true : false;
          this.property.active   = (this.property.active == '1')   ? true : false;
          this.property.default  = (this.property.default == '1')  ? true : false;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Entityproperty.vue?75b5f526